import { useEffect, useState } from "react";

export function useBlenderTerrainManifest(
  href = "/research-terrain/configuration-landscape.manifest.json"
) {
  const [manifest, setManifest] = useState(null);

  useEffect(() => {
    let alive = true;

    fetch(href)
      .then((response) => {
        if (!response.ok) throw new Error(`manifest ${response.status}`);
        return response.json();
      })
      .then((payload) => {
        if (alive) setManifest(payload);
      })
      .catch(() => {
        if (alive) setManifest(null);
      });

    return () => {
      alive = false;
    };
  }, [href]);

  return manifest;
}
